import {Category, Collection, Item, Order, OrderedItem} from "../model";
import conf from "../config"

const api = conf.apiUrl;

class ApiService {
  async loadCategories():Promise<Category[]> {
    let response = await fetch(`${api}/category`, { method: 'get'});
    let result = await response.json();
    return result.filter((it:any) => it != null).map((it:any) => new Category(it));
  }

  async loadCategory(id:number):Promise<Category> {
    let response = await fetch(`${api}/category/${id}`, { method: 'get'});
    let result = await response.json();
    return new Category(result);
  }

  async loadCategoryItems(id:number):Promise<Item[]> {
    let response = await fetch(`${api}/category/${id}/loadItems`, { method: 'get'});
    let result = await response.json();
    return result.filter((it:any) => it != null).map((it:any) => new Item(it));
  }

  async loadCollections():Promise<Collection[]> {
    let response = await fetch(`${api}/collection`, { method: 'get'});
    let result = await response.json();
    return result.filter((it:any) => it != null).map((it:any) => new Collection(it));
  }

  async loadCollection(id:number):Promise<Collection> {
    let response = await fetch(`${api}/collection/${id}`, { method: 'get'});
    let result = await response.json();
    return new Collection(result);
  }

  async loadCollectionItems(id:number):Promise<OrderedItem[]> {
    let response = await fetch(`${api}/collection/${id}/loadItems`, { method: 'get'});
    let result = await response.json();
    return result.filter((it:any) => it != null).map((it:any) => new OrderedItem(it));
  }

  async loadItem(id:number):Promise<Item> {
    let response = await fetch(`${api}/item/${id}`, { method: 'get'});
    let result = await response.json();
    return new Item(result);
  }

  async createOrder(order:Order):Promise<OrderResponse> {
    let response = await fetch(`${api}/order`, {
      method: 'post',
      body: JSON.stringify(order),
      headers: new Headers({'content-type': 'application/json'}),
    });
    let result = await response.json();
    return result as OrderResponse;
  }

  async executeOrder(paymentId:string, payerID:string):Promise<any> {
    return fetch(`${api}/order/${paymentId}/execute_payment?payer_id=${payerID}`, {
      method: 'post'
    });
  }

  async cancelOrder(paymentId:string):Promise<any> {
    return fetch(`${api}/order/${paymentId}/cancel_payment`, {
      method: 'post'
    });
  }

}

export class OrderResponse {
  order:any;
  approve_url!:string;
}

// Export a singleton instance in the global namespace
export const apiService = new ApiService();